module.exports = __webpack_public_path__ + "static/img/or-add-your-own.5a15464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/or-add-your-own.png
// module id = CO3W
// module chunks = 0